/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CarBodyTypeFilter } from '../models/CarBodyTypeFilter';
import type { FuelTypeFilter } from '../models/FuelTypeFilter';
import type { StockStateModelReportModel } from '../models/StockStateModelReportModel';
import type { StockStateReportModel } from '../models/StockStateReportModel';
import type { StockStateReportSettingsModel } from '../models/StockStateReportSettingsModel';
import type { StockStateReportSettingsSubmitModel } from '../models/StockStateReportSettingsSubmitModel';
import type { TransmTypeFilter } from '../models/TransmTypeFilter';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StockStateReportService {

  /**
   * Get stock vehicles from defined branch
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param minAge 
   * @param maxAge 
   * @param transmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param bodyType
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param fuel
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param minPrice 
   * @param maxPrice 
   * @param minMileage 
   * @param maxMileage 
   * @param models 
   * @returns StockStateReportModel Success
   * @throws ApiError
   */
  public static getStockState(
branch?: BranchType,
minAge?: number,
maxAge?: number,
transmission?: TransmTypeFilter,
bodyType?: CarBodyTypeFilter,
fuel?: FuelTypeFilter,
minPrice?: number,
maxPrice?: number,
minMileage?: number,
maxMileage?: number,
models?: Array<number>,
): CancelablePromise<Array<StockStateReportModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/stock-state',
      query: {
        'Branch': branch,
        'MinAge': minAge,
        'MaxAge': maxAge,
        'Transmission': transmission,
        'BodyType': bodyType,
        'Fuel': fuel,
        'MinPrice': minPrice,
        'MaxPrice': maxPrice,
        'MinMileage': minMileage,
        'MaxMileage': maxMileage,
        'Models': models,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Get stock vehicles from defined branch by model id (dd_model crmId)
   * @param id Vehicle model id (dd_model crmId)
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param minAge 
   * @param maxAge 
   * @param transmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param bodyType
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param fuel
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param minPrice 
   * @param maxPrice 
   * @param minMileage 
   * @param maxMileage 
   * @param models 
   * @returns StockStateModelReportModel Success
   * @throws ApiError
   */
  public static getStockState1(
id: number,
branch?: BranchType,
minAge?: number,
maxAge?: number,
transmission?: TransmTypeFilter,
bodyType?: CarBodyTypeFilter,
fuel?: FuelTypeFilter,
minPrice?: number,
maxPrice?: number,
minMileage?: number,
maxMileage?: number,
models?: Array<number>,
): CancelablePromise<StockStateModelReportModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/stock-state/{id}',
      path: {
        'id': id,
      },
      query: {
        'Branch': branch,
        'MinAge': minAge,
        'MaxAge': maxAge,
        'Transmission': transmission,
        'BodyType': bodyType,
        'Fuel': fuel,
        'MinPrice': minPrice,
        'MaxPrice': maxPrice,
        'MinMileage': minMileage,
        'MaxMileage': maxMileage,
        'Models': models,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Set model required count on stock
   * @param requestBody Model settings
   * @returns boolean Success
   * @throws ApiError
   */
  public static postStockStateSettings(
requestBody?: StockStateReportSettingsSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/stock-state/settings',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Set model required count on stock
   * @param id Model id (dd_model crmId)
   * @param branchId Branch Id
   * @returns StockStateReportSettingsModel Success
   * @throws ApiError
   */
  public static getStockStateSettings(
id: number,
branchId?: number,
): CancelablePromise<StockStateReportSettingsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/stock-state/settings/{id}',
      path: {
        'id': id,
      },
      query: {
        'branchId': branchId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Get stock model list from defined branch
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param minAge 
   * @param maxAge 
   * @param transmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param bodyType
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param fuel
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param minPrice 
   * @param maxPrice 
   * @param minMileage 
   * @param maxMileage 
   * @param models 
   * @returns string Success
   * @throws ApiError
   */
  public static getStockStateModelList(
branch?: BranchType,
minAge?: number,
maxAge?: number,
transmission?: TransmTypeFilter,
bodyType?: CarBodyTypeFilter,
fuel?: FuelTypeFilter,
minPrice?: number,
maxPrice?: number,
minMileage?: number,
maxMileage?: number,
models?: Array<number>,
): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/stock-state/model-list',
      query: {
        'Branch': branch,
        'MinAge': minAge,
        'MaxAge': maxAge,
        'Transmission': transmission,
        'BodyType': bodyType,
        'Fuel': fuel,
        'MinPrice': minPrice,
        'MaxPrice': maxPrice,
        'MinMileage': minMileage,
        'MaxMileage': maxMileage,
        'Models': models,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

}
